import React, {FC, useState} from "react"

import {useIntl} from "@irati/utils/lang"
import Tabs from "@irati/ui/src/Tabs"

import BenefitsOverview from "../../../components/Reporting/Benefits/Overview"

export enum BenefitsTabs {
  overview = "Overview"
}

interface Props {}

const Benefits: FC<Props> = () => {
  const [selectedCategory, setSelectedCategory] = useState<BenefitsTabs>(BenefitsTabs.overview)
  const {formatMessage} = useIntl()

  const handleOnChange = (value) => {
    setSelectedCategory(value)
  }

  const getTabs = () => {
    return [
      {
        title: formatMessage({id: "admin.reporting.tabs.overview"}),
        key: BenefitsTabs.overview,
        component: <BenefitsOverview />
      }
    ]
  }

  return (
    <Tabs
      id="adminSection_benefitsOverviewTabs"
      mountOnEnter
      unmountOnExit
      activeKey={selectedCategory}
      onSelect={handleOnChange}
      tabs={getTabs()}
    />
  )
}

export default Benefits
